class ColorSwatches extends HTMLElement {
  constructor() {
    super();
    this.productColors = this.querySelector('.product-colors');

    this.listEl = this.closest('li.grid__item') || this.closest('.flickity__slider .carousel__cell');
    if (this.listEl) this.cardWrapper = this.listEl.querySelector('.card-wrapper');
    if (this.cardWrapper) this.productColorsEl = this.cardWrapper.querySelector('.product-colors');
    if (this.productColorsEl) {
      this.rightArrowEl = this.productColorsEl.querySelector('.product-colors-scroll-right');
      this.addEventListener('scroll', this.onRightArrowScroll.bind(this));
    }
    this.renderRightArrow();
    if (this.listEl) {
      const resizeObserver = new ResizeObserver(() => {
        this.renderRightArrow();
      });
      resizeObserver.observe(this.listEl);
    }

    if (this.rightArrowEl) this.rightArrowEl.addEventListener('click', this.onRightArrowClick.bind(this));

    this.addEventListener('change', this.onColorSwatchChange);

    this.resizeObserver = new ResizeObserver(this.calculateMaxColors.bind(this));
    this.resizeObserver.observe(this);

    if (this.dataset.event == 'hover') {
      if (this.productColors) {
        const swatches = this.productColors.querySelectorAll('label.color');
        swatches.forEach((swatch) => {
          const listener = this.onColorSwatchHover.bind(this);
          swatch.addEventListener('mouseenter', listener);
        });
      }
    }

    this.triggerYotpo();
  }

  triggerYotpo() {
    const thisYotpo = this.parentElement.parentElement.querySelector('.yotpo-widget-instance');
    if (thisYotpo && yotpoWidgetsContainer) {
      const instanceId = thisYotpo.dataset.yotpoInstanceId;
      yotpoWidgetsContainer.initWidget(`${instanceId}`, thisYotpo);
    }
  }

  onColorSwatchHover(event) {
    const input = event.target.previousElementSibling;
    if (!input.checked) {
      input.checked = true;
      this.dispatchEvent(new Event('change', { bubbles: true }));
      this.triggerYotpo();
    }
  }

  onColorSwatchChange() {
    this.updateOptions();
    this.updateMasterId();
    if (this.currentVariant) {
      const html = this.getProductData().find((product) => product.id.toString() === this.connectedProductId).html;
      this.renderProduct(html);
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checked = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return {
        value: checked.value,
        connectedProductId: checked.dataset.connectedProductId,
        connectedProductHandle: checked.dataset.handle,
      };
    });
  }

  updateMasterId() {
    this.productId = this.dataset.productId;
    this.connectedProductId = this.options[0].connectedProductId;
    this.connectedProductHandle = this.options[0].connectedProductHandle;
    this.currentVariant = this.options[0].value;
  }

  renderProduct(html) {
    const destination = document.querySelector(`#CardWrapper-${this.productId}`);

    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');

    const source = parsedHtml.querySelector(`#CardWrapper-${this.connectedProductId}`);

    if (destination && source) {
      const destinationCardInner = destination.querySelector('.card > .card__inner');
      const sourceCardInner = source.querySelector('.card > .card__inner');
      if (destinationCardInner && sourceCardInner) destinationCardInner.innerHTML = sourceCardInner.innerHTML;

      const destinationCardInfoMain = destination.querySelector('.card > .card__content > .card__information > .card-info__main');
      const sourceCardInfoMain = source.querySelector('.card > .card__content > .card__information > .card-info__main');
      if (destinationCardInfoMain && sourceCardInfoMain) destinationCardInfoMain.innerHTML = sourceCardInfoMain.innerHTML;

      const destinationCardInfoPrice = destination.querySelector('.card > .card__content > .card__information > .card-info__price');
      const sourceCardInfoPrice = source.querySelector('.card > .card__content > .card__information > .card-info__price');
      if (destinationCardInfoPrice && sourceCardInfoPrice) destinationCardInfoPrice.innerHTML = sourceCardInfoPrice.innerHTML;

      const destinationCardQuickAdd = destination.querySelector('.card > .card__content > .quick-add');
      const sourceCardQuickAdd = source.querySelector('.card > .card__content > .quick-add');
      if (destinationCardQuickAdd && sourceCardQuickAdd) destinationCardQuickAdd.innerHTML = sourceCardQuickAdd.innerHTML;

      const destinationCardBadge = destination.querySelector('.card > .card__content > .card__badge');
      const sourceCardBadge = source.querySelector('.card > .card__content > .card__badge');
      if (destinationCardBadge && sourceCardBadge) destinationCardBadge.innerHTML = sourceCardBadge.innerHTML;

      const destinationPromoCode1 = destination.querySelector('.card > .card__content > .card__information [data-promo-code-1]');
      const sourcePromoCode1 = source.querySelector('.card > .card__content > .card__information [data-promo-code-1]');
      if (destinationPromoCode1 && sourcePromoCode1) destinationPromoCode1.parentNode.replaceChild(sourcePromoCode1, destinationPromoCode1);

      const destinationPromoCode2 = destination.querySelector('.card > .card__content > .card__information [data-promo-code-2]');
      const sourcePromoCode2 = source.querySelector('.card > .card__content > .card__information [data-promo-code-2]');
      if (destinationPromoCode2 && sourcePromoCode2) destinationPromoCode2.parentNode.replaceChild(sourcePromoCode2, destinationPromoCode2);

      const video = destinationCardInner.querySelector('video');
      if (video) {
        video.play().catch((e) => console.warn('Video play failed:', e));
      }
    }
  }

  getProductData() {
    if (!this.productData) {
      const jsonElement = this.querySelector('[type="application/json"]');
      if (!jsonElement) {
        console.error('Missing JSON data element');
        return [];
      }

      try {
        const jsonContent = jsonElement.textContent.trim();
        if (!jsonContent) {
          console.error('Empty JSON data');
          return [];
        }

        this.productData = JSON.parse(jsonContent);
      } catch (e) {
        console.error('Failed to parse product data JSON:', e);
        return [];
      }
    }
    return this.productData;
  }

  calculateMaxColors() {
    if (!this.productColors) return;

    const additionalColors = this.productColors.querySelector('.product-colors-additional-colors');
    if (!additionalColors) return;

    const allSwatches = this.productColors.querySelectorAll('label.color');
    const availableWidth = this.offsetWidth;

    if (!allSwatches.length || !availableWidth) return;

    // Cache computed values
    const sampleSwatch = allSwatches[0];
    const swatchStyle = getComputedStyle(sampleSwatch);
    const swatchWidth = sampleSwatch.offsetWidth + parseFloat(swatchStyle.marginRight);

    const additionalStyle = getComputedStyle(additionalColors);
    const additionalColorsWidth = additionalColors.offsetWidth + parseFloat(additionalStyle.marginRight || 0);

    // Calculate max visible colors
    const maxColorsInitial = parseInt(additionalColors.dataset.maxColors) || 6;
    const maxColorsFit = Math.floor((availableWidth - additionalColorsWidth) / swatchWidth);
    const maxVisible = Math.min(maxColorsInitial, maxColorsFit);
    const swatchesCount = parseInt(additionalColors.dataset.colorsCount) || 0;
    const hiddenCount = Math.max(0, swatchesCount - maxVisible);

    // Update visibility
    allSwatches.forEach((swatch, index) => {
      swatch.style.display = index < maxVisible ? '' : 'none';
    });

    // Update additional colors indicator
    if (hiddenCount > 0) {
      additionalColors.style.display = 'inline-flex';
      additionalColors.textContent = `+${hiddenCount}`;
    } else {
      additionalColors.style.display = 'none';
      additionalColors.textContent = '';
    }

    this.dataset.maxColors = maxVisible;
  }

  renderRightArrow() {
    if (!this.productColorsEl || !this.rightArrowEl) return;
    if (this.listEl.getBoundingClientRect().width < this.productColorsEl.getBoundingClientRect().width) {
      this.style.width = `${this.cardWrapper.getBoundingClientRect().width - 25}px`;
      this.rightArrowEl.style.display = 'flex';
      this.listEl.classList.add('overflowing');
    } else {
      this.rightArrowEl.style.display = 'none';
      this.listEl.classList.remove('overflowing');
    }
  }

  onRightArrowClick() {
    const scrollWidth = 4 * (this.productColorsEl.querySelector('.color').offsetWidth + 5);
    this.scrollBy({
      left: scrollWidth,
      behavior: 'smooth',
    });
  }

  onRightArrowScroll() {
    if (!this.rightArrowEl) return;
    const position = this.productColorsEl.getBoundingClientRect().left - this.getBoundingClientRect().left;
    const overflow = this.productColorsEl.offsetWidth - this.offsetWidth;
    if (position - 2 <= -overflow) {
      this.rightArrowEl.style.display = 'none';
    } else {
      this.rightArrowEl.style.display = 'flex';
    }
  }
}

ColorSwatches.productData = [];

customElements.define('color-swatches', ColorSwatches);
